export default "__VITE_ASSET__BmoHTZMx__"